import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import TitleStyled from "../components/styles/titleStyles"
import FeedBox from "../components/feedBox"
import uuid from "react-uuid"
import FeedJobStyled from "./styles/FeedJobStyles"

const FeedJob = ({ heading }) => {
  const data = useStaticQuery(graphql`
    query {
      swapi {
        carrerCollection {
          slug
          cityFeed
          buttonFeed
          headingFeed
        }
      }
    }
  `)
  const { carrerCollection } = data.swapi

  return (
    <FeedJobStyled>
      <section className="feed" id="careerFeed">
        <div className="container">
          <TitleStyled
            textAlign="center"
            linePosition="center"
            color="#000"
            lineColor="#000"
          >
            <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
          </TitleStyled>
        </div>
        <div
          className={`container container__feed carrer__feed--3 carrer__items--${carrerCollection.length}`}
        >
          {carrerCollection.length
            ? carrerCollection.map(item => {
                return (
                  <div key={uuid()} className="feed__item">
                    <FeedBox
                      title={item.headingFeed}
                      descirption={item.cityFeed}
                      link={"/career/" + item.slug}
                      linkText={item.buttonFeed}
                      linkPostion="bottom"
                    />
                  </div>
                )
              })
            : ""}
        </div>
      </section>
    </FeedJobStyled>
  )
}

export default FeedJob
